<div class="container">
    <div class="me-landing-page-offer">
        <div class="me-landing-page-offer__save">
            <div>{{'Save' | translate}}</div>
            <div>€{{data['oldPrice'] - data['newPrice']}}</div>
        </div>
        <div class="me-landing-page-offer__block">
            <div class="me-landing-page-offer__sub_title">
                {{data.subHeadline}}
            </div>
            <div class="me-landing-page-offer__title">
                {{data.headline}}
            </div>
            <div class="me-landing-page-offer__description" [innerHTML]="data.text | storyblokRichtext">
            </div>
            <div class="me-landing-page-offer__action">
                <storyblok-link [classList]="'btn btn--primary'" [data]="data.primaryCTA"></storyblok-link>
                <div class="me-landing-page-offer__money">
                    <span class="me-landing-page-offer__money__normal">€{{data['oldPrice']}}</span>
                    <span>{{ 'only' | translate }}</span>
                    <span class="me-landing-page-offer__money__discount">€{{data['newPrice']}}</span>
                </div>
            </div>
        </div>
    </div>
</div>